import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { PagePermission, PermissionActions } from '@enums';
import { currentUserSelector } from '@selectors/user';
import { userHasPagePermission } from '@utils';

export const hasPermissionPage = (
  permissionPages: PagePermission[],
  permissionActions: PermissionActions[]
) => {
  const currentUser = useSelector(currentUserSelector);

  return useMemo(() => {
    if (!currentUser) {
      return false;
    }

    return userHasPagePermission(currentUser, permissionPages, permissionActions);
  }, [currentUser, permissionActions]);
};
